const axios = require('axios').default;

function init() {

  const elModalTrigger = document.querySelector('[data-micromodal-trigger]');

  if (elModalTrigger && document.cookie.match(/^(.*;)?\s*biopromise\s*=\s*[^;]+(.*)?$/)) {
    delete elModalTrigger.dataSet.micromodalTrigger;
  }

  const elBioPromiseForm = document.querySelector('#bio-promise-form');

  if (!elBioPromiseForm) {
    return;
  }
  elBioPromiseForm.addEventListener('submit', (event) => {
    event.preventDefault();
    axios.post(wpApiSettings.root + 'planet-company/v2/bio-promise/', elBioPromiseForm, {
      headers:{
        'X-WP-Nonce': wpApiSettings.nonce,
        'Content-Type': 'application/json'
      }
    })
    .then(function (response) {
      if (response) {
        elModalTrigger.textContent = 'Kiitos liittymisestä!';
        setCookie('biopromise', 1, 365);
        location.reload();
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  });

  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

}

export default {init};
